import HolidaySettingsList from "@/modules/setting/stores/holiday/holiday_settings_list.store";
import HolidaySettingsFrom from "@/modules/setting/stores/holiday/holiday_settings_form.store";

export default {
  modules: {
    HolidaySettingsList,
    HolidaySettingsFrom,
  },
};
